export default {
    isAuthenticated: false,
    userInfo: {}
}